module.exports = __webpack_public_path__ + "static/media/moduleSet_i1o0.44acccb1.jpg";